import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";

const Seo = ({ title, description, image, slug }) => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          title
          description
          image
          siteUrl
        }
      }
    }
  `);

  const metaDescription = description || data.site.siteMetadata.description;

  const metaImage =
    typeof image === "string" && image.startsWith("http")
      ? image
      : `${data.site.siteMetadata.siteUrl}${image || data.site.siteMetadata.image}`;

  const metaUrl = slug
    ? `${data.site.siteMetadata.siteUrl}/blog${slug}`
    : data.site.siteMetadata.siteUrl;

  return (
    <>
      <title>
        {title} | {data.site.siteMetadata.title}
      </title>
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={metaUrl} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />
    </>
  );
};

export default Seo;
